module.exports = __webpack_public_path__ + "static/media/error.808fe86a.svg";